export const dupLangEn = {
  dup: {
    title: 'Duplicate Scanner',
    subtitle: 'Find and merge customer duplicates',
    scan: 'Start Scan',
    scanning: 'Scanning...',
    // Fields
    fieldEmail: 'Email',
    fieldPhone: 'Phone',
    fieldTaxNumber: 'Tax Number',
    fieldCompanyName: 'Company Name',
    fieldFullName: 'Full Name',
    // Confidence
    confidenceHigh: 'High',
    confidenceMedium: 'Medium',
    confidenceLow: 'Low',
    confidence: 'Match',
    // Results
    results: 'Results',
    noDuplicates: 'No duplicates found',
    duplicatesFound: '{count} duplicates found',
    totalCustomers: 'Total Customers',
    totalDuplicates: 'Affected Customers',
    scannedAt: 'Scanned',
    // Actions
    merge: 'Merge',
    ignore: 'Ignore',
    view: 'View',
    // Merge modal
    mergeTitle: 'Merge Customers',
    primary: 'Primary (kept)',
    secondary: 'Secondary (deleted)',
    selectPrimary: 'Select which customer to keep',
    fieldByField: 'Field-by-field merge',
    keepPrimary: 'Keep primary value',
    keepSecondary: 'Keep secondary value',
    confirmMerge: 'Confirm Merge',
    mergeWarning: 'The secondary customer will be permanently deleted!',
    cancel: 'Cancel',
    // Real-time
    duplicateWarning: 'Possible duplicate!',
    duplicateFound: '{count} customers found with similar data',
    alreadyExists: 'A customer with this data already exists',
  },
};
